/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconSliders(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 21 21"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.588 1.395a.6.6 0 1 0-1.2 0v3.76a.6.6 0 1 0 1.2 0v-1.28h6.927a.6.6 0 0 0 0-1.202h-6.927zM.131 3.274a.6.6 0 0 1 .6-.601h7.505a.6.6 0 0 1 0 1.203H.732a.6.6 0 0 1-.6-.602M10.112 10.192a.6.6 0 0 0 0 1.203h9.403a.6.6 0 0 0 0-1.203zM.131 10.793a.6.6 0 0 1 .6-.601H5.76V8.914a.6.6 0 1 1 1.201 0v3.7589999999999995a.6.6 0 1 1-1.2 0v-1.278H.731a.6.6 0 0 1-.6-.602M14.464 18.914v1.278a.6.6 0 1 1-1.2 0v-3.76a.6.6 0 1 1 1.2 0v1.279h5.044a.6.6 0 0 1 0 1.203zM.116 18.312a.6.6 0 0 1 .6-.602h9.396a.6.6 0 0 1 0 1.203H.716a.6.6 0 0 1-.6-.601"
      />
    </svg>
  );
}
